module.exports = __webpack_public_path__ + "06147b6cd88c7346cecd1edd060cd5de.ttf";